import { CommonModule, DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { PrimeModuleModule } from '../../../shared/modules/prime-module/prime-module.module';
import { IconComponent } from '../../atoms/icon/icon.component';
import { gsap } from "gsap";
import { ConsultaService } from '../../../services/consulta.service';
import { RestitucionService } from '../../../services/restitucion.service';
import { CardComponent } from '../../atoms/card/card.component';
import { ImportanteComponent } from '../importante/importante.component';
import { BodyComponent } from '../../atoms/body/body.component';
import { TextComponent } from '../../atoms/text/text.component';
import { HeadComponent } from '../../atoms/head/head.component';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { FormatoCostosDesde } from '../../../pipes/formatoCotosDesde.pipe';
import { ReportService } from '../../../services/report.service';

@Component({
  selector: 'app-progress-bar-stepper-periodos-restitucion',
  standalone: true,
  imports: [
    CommonModule,
    CommonNgModule,
    PrimeModuleModule,
    IconComponent,
    CardComponent,
    ImportanteComponent,
    BodyComponent,
    TextComponent,
    HeadComponent,
    FormatoCostosDesde
  ],
  providers: [
    ConsultaService,
    RestitucionService,
    ReportService
  ],
  templateUrl: './progress-bar-stepper-periodos-restitucion.component.html',
  styleUrls: ['./progress-bar-stepper-periodos-restitucion.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgressBarStepperPeriodosRestitucionComponent {
  viewControls:boolean = false;
  beneficiarioTitular:any;
  datosRestituir:any;
  @Input() CurrentRutUser:any;
  
  @ViewChild("scrollBarContent") scrollBarContent!: ElementRef;
  @ViewChildren('stepItem') steps!: QueryList<ElementRef>; // Selector dinámico
  activeIndicador:any = 'default';
  headTable = [
    {title: 'N° de cuota', field: 'nCoutas'},
    {title: 'Periodo devengo proyectado', field: 'periodo'},
    {title: 'Monto (UF)', field: 'monto'}
  ];
  dataTable:any = [];
  periodos:any = [];
  private contentWidth: number = 0;
  private containerWidth: number = 0;
  
  currenteYear:any;

  constructor(
    private renderer: Renderer2,
    private readonly restitucionService: RestitucionService,
    private readonly reportService: ReportService
  ){
    this.currenteYear = new Date().getFullYear();
  }
  
  ngAfterViewInit() {
    // this.getBeneficiario();
   
    this.getPeriodos(this.CurrentRutUser);
    this.infoCuentaRestitucion();
  }

  // private getBeneficiario(): void {
  //   this.beneficiarioService.getTitular()
  //       .subscribe( titular => {
  //         this.beneficiarioTitular = titular;
  //         console.log('this.beneficiarioTitular', this.beneficiarioTitular);
  //         this.getPeriodos(this.beneficiarioTitular.rut);
  //         this.infoCuentaRestitucion(this.beneficiarioTitular);
  //       });
  // }

  moveScroll($event: any) {
    const content = this.scrollBarContent.nativeElement;

    // Calcula el ancho total del contenido y el ancho del contenedor
    this.contentWidth = content.scrollWidth;
    this.containerWidth = content.offsetWidth;
    
    // console.log('content', content);
    // Verificar si hay al menos un elemento `li` para obtener el ancho
    const stepWidth = this.steps.first ? this.steps.first.nativeElement.offsetWidth : 0;
    
    // Obtén la posición actual de desplazamiento en el eje X
    const currentTranslateX = gsap.getProperty(content, "x") as number || 0;

    if ($event === 'next') {
        // Calcular el límite de desplazamiento hacia la izquierda
        const maxScroll = -(this.contentWidth - this.containerWidth);
        if (currentTranslateX > maxScroll) {
          this.activeIndicador = 'back';
            gsap.to(content, { x: Math.max(currentTranslateX - stepWidth, maxScroll), duration: 1, ease: "power2.inOut" });
        }
    }
    if ($event === 'back') {
        // Limitar el desplazamiento para que no pase del inicio
        if (currentTranslateX < 0) {
          this.activeIndicador = 'next';
            gsap.to(content, { x: Math.min(currentTranslateX + stepWidth, 0), duration: 1, ease: "power2.inOut" });
        }
    }
  }

  selectedIndex: number | null = null; // Variable para almacenar el índice seleccionado

  openPeriodo(periodo: any, index: number) {
    // console.log('periodo', periodo);
    this.dataTable    = [];
  
    // this.auxDataTable.ppaNumCuota  = periodo.ppaNumCuota;
    // this.auxDataTable.dvgPeriodo   = this.datePipe.transform(periodo.dvgPeriodo, 'dd/MM/yyyy' );;
    // this.auxDataTable.ppaMonto   = periodo.ppaMonto;
    this.dataTable = periodo.detallesPPA;
    // console.log('this.dataTable', this.dataTable);
  
    const arrayStepPeriodos = this.steps.toArray();
  
    // Si hay un índice seleccionado previamente, remueve la clase de ese elemento
    if (this.selectedIndex !== null && this.selectedIndex !== index) {
      this.renderer.removeClass(arrayStepPeriodos[this.selectedIndex].nativeElement, "selected");
    }
  
    // Agrega la clase 'selected' al elemento actual
    this.renderer.addClass(arrayStepPeriodos[index].nativeElement, "selected");
  
    // Actualiza el índice seleccionado
    this.selectedIndex = index;
  
    // console.log('openPeriodo::', {
    //   'arrayStepPeriodos': arrayStepPeriodos[index].nativeElement,
    //   'index': index
    // });
  }
  
  
  
  getPeriodos(rut:any) {
    // console.log('getPeriodos::::' ,rut);
    this.restitucionService.detallePlanPago().subscribe( (periodos:any) => {
      if(periodos.code != 1) {
        this.periodos = periodos.response;
        // Configura la posición inicial en 0
        this.dataTable = this.periodos[0].detallesPPA;
        const widthContent = gsap.getProperty(this.scrollBarContent.nativeElement, "width");
        // console.log('widthContent', widthContent);
        setTimeout(() => {
          this.calculateWidths();
          this.selectCurrentYear();
        }, 1000);
      }else if (periodos.code === 1) {
        // alert(periodos.message);
      }
      // console.log('periodos:', periodos);
    });
  }

  selectCurrentYear() {
    // Encuentra el periodo actual y su índice
    const currentYearIndex = this.periodos.findIndex((year:any) => year.periodo === this.currenteYear.toString());
    const matchCurrentYear = this.periodos.find((year:any) => year.periodo === this.currenteYear.toString());

    // Verifica que ambos coincidan y no sean -1
    if (matchCurrentYear && currentYearIndex !== -1) {
        // Llama a openPeriodo con el periodo y el índice encontrados
        // console.log('MATCH' , {
        //   matchCurrentYear,
        //   currentYearIndex,
        //   'this.periodos': this.periodos,
        //   'this.steps': this.steps
        // })
        this.openPeriodoMatch(matchCurrentYear, currentYearIndex);
    } else {
        // console.log("No se encontró el periodo correspondiente al año actual.");
    }
  }

  openPeriodoMatch(periodo:any, index:any) {
    this.dataTable    = [];
    this.dataTable = periodo.detallesPPA;
    let arrayStepPeriodos = [];
    arrayStepPeriodos = this.steps.toArray();
    // console.log('arrayStepPeriodos', arrayStepPeriodos);
    this.renderer.addClass(arrayStepPeriodos[index].nativeElement, "selected");

    this.selectedIndex = index;
  }


  calculateWidths() {
    // Obtiene el ancho del contenedor <ul>
    const containerWidth = this.scrollBarContent.nativeElement.offsetWidth;

    // Calcula la suma del ancho de todos los elementos <li>
    let totalLiWidth = 0;
    this.steps.forEach((stepItem) => {
      totalLiWidth += stepItem.nativeElement.offsetWidth;
    });

    // Compara los anchos
    if (totalLiWidth > containerWidth) {
      // console.log('La suma del ancho de los <li> es mayor al ancho del contenedor.');
      this.viewControls = true;
      this.activeIndicador = 'next';

    } else {
      // console.log('La suma del ancho de los <li> es menor o igual al ancho del contenedor.');
      this.viewControls = false;
    }

    // console.log('Ancho total de <li>:', totalLiWidth);
    // console.log('Ancho del contenedor:', containerWidth);
  }


  infoCuentaRestitucion() {
    this.restitucionService.infoCuentaRestitucion().subscribe( (infoCuenta:any) => {
      // console.log('infoCuentaRestitucion', infoCuenta);
      if(infoCuenta) {
        this.datosRestituir = infoCuenta;
      }

    })
  }

  downloadPlandePago(){
    // alert('Descarga cartola.');
    // console.log('this.CurrentRutUser', this.TypeApp);
    // console.log('this.CurrentRutUser typo', typeof this.TypeApp);
    // SA = SITIO PRIVADO
    // SI = CONSULTA INTEGRAL
    // SP = SITIO PUBLICO
    // SM = APP MOVIL
    // switch (this.TypeApp) {
    //   case '0':
    //     this.origen = 'SA';
    //   break;
    //   case '1':
    //     this.origen = 'SP';
    //   break;
    //   case '2':
    //     this.origen = 'SM';
    //   break;
    //   case '3':
    //     this.origen = 'SI';
    //   break;
    // }

    // console.log('this.origen', this.origen);
    this.reportService.downloadFile('PlanPagoRestitucion', 'PlanPagoRestitucion', 'pdf', {
      "RUT_AFILIADO": this.CurrentRutUser,
      "ORIGEN": 'SA' //this.origen
    } );

  }
}
